import { Grid, Tooltip } from '@material-ui/core';

import { FormSwitchField } from '~ui-kit';

type UnitNotificationSettingsEventsListProps = {
  event: { faultCode: string; eventLabel: string };
  index: number;
};

export const UnitNotificationSettingsEventsList = ({ event, index }: UnitNotificationSettingsEventsListProps) => (
  <Tooltip title={event.faultCode} placement="left" key={index} arrow>
    <Grid item xs={12} md={4} key={index} style={{ maxWidth: '100%' }}>
      <FormSwitchField activeText={event.eventLabel} text={event.eventLabel} name={`events[${index}].isEnabled`} />
    </Grid>
  </Tooltip>
);
